(() => {
  const cartPath = `${window.Shopify?.routes?.root || '/'}cart`.replace(/\/$/, '');
  async function openCart() {
    await customElements.whenDefined('cart-drawer');
    const drawer = document.getElementById('cart-drawer');
    if (drawer) await drawer.show();
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download') || link.getAttribute('aria-controls') === 'cart-drawer') return;
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin === window.location.origin && destination.pathname.replace(/\/$/, '') === cartPath) {
      event.preventDefault();
      openCart();
    }
  });

  const current = new URL(window.location.href);
  if (current.searchParams.get('ft_cart') === '1') {
    current.searchParams.delete('ft_cart');
    history.replaceState(history.state, '', current.href);
    openCart();
  }
})();
